<button
  mat-icon-button
  id="menu-button"
  [ngClass]="menuButtonClass"
  tooltip-position="below"
  matTooltipShowDelay="500"
  [matTooltip]="(sidenavOpened ? 'menu.close' : 'menu.open') | translate"
  (click)="onToggleSidenavClick()"
>
  <mat-icon>menu</mat-icon>
</button>
